import React from 'react';
import loadable from '@loadable/component';
import { compose } from '@/utils/story-composer';

const Widget = loadable(() => import('@typeform/embed-react').then(typeform => typeform.Widget), {
	ssr: true,
});

function TypeForm({ typeformId, height }) {
	return <Widget style={{ height: `${height}px` }} id={typeformId} />;
}

compose('typeform', TypeForm);
export default TypeForm;
